<template>
  <div>
    <button v-can:edit-exploitation class='action-btn add-btn flex items-center' @click='showAddTypeSol'>Ajouter un type de sol</button>
    <table>
      <thead>
        <tr>
          <th>Type(s) de sol</th>
          <th class="has-tooltip" v-tooltip="{ content : getTooltipMessage('ru') }"><span>RU*</span></th>
          <th class="has-tooltip" v-tooltip="{ content : getTooltipMessage('rfu') }"><span>RFU</span></th>
          <th>Surface en ha</th>
          <th/>
        </tr>
      </thead>
      <tbody>
        <tr v-for='typeSol in sols' :key='typeSol.id_ref_type_sol'>
          <td><div>{{ typeSol.nom }}</div></td>
          <td :class='{ has_error : errors.has(typeSol.id_ref_type_sol + "_ru")}'>
            <v-field-integer v-validate='{ required : true, min_value : 0 }' v-model='typeSol.ru' :name='typeSol.id_ref_type_sol + "_ru"' data-vv-as='RU' />
          </td>
          <td>
            <v-field-integer v-validate='{ required : true, min_value : 0 }' v-model='typeSol.rfu' :name='typeSol.id_ref_type_sol + "_rfu"' data-vv-as='RFU' />
          </td>
          <td>
            <v-field-integer v-validate='{ required : true, min_value : 0 }' v-model='typeSol.surface' :name='typeSol.id_ref_type_sol + "_surf"' data-vv-as='surface' />
          </td>
          <td class='align-center' v-can:edit-exploitation>
            <div><button class='action-icon delete-btn' @click='deleteRow(typeSol)'/></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'SolIlotTable',
  inject: ['$validator'],
  mixins: [mixinTooltip],

  props: {
    sols: {
      type: Array,
      required: true
    }
  },

  methods: {
    ...mapActions('confirm', ['confirm']),
    ...mapActions('select', ['select']),
    showAddTypeSol () {
      this.select({
        title: "Ajout d'un type de sol",
        selector: 'v-select-type-sol',
        props: {
          selected: this.sols
        }
      }).then(value => {
        if (value !== false) {
          this.$emit('addRow', value)
        }
      })
    },
    deleteRow (idRefTypeSol) {
      this.confirm({
        title: 'Suppression type de sol',
        message: 'Êtes vous-sûr de vouloir supprimer ce type de sol ?',
        okText: 'Supprimer'
      }).then(confirmation => {
        if (confirmation) {
          this.$emit('deleteRow', idRefTypeSol)
        }
      })
    }
  }
}
</script>
